import { create } from 'zustand';
import { readLS, writeLS } from '@/services/storage/local';
import { ROLES, type RoleId } from '@/data/roles';

type RoleState = {
  role: RoleId;
  setRole: (r: RoleId) => void;
  hasLaudo: () => boolean;
};

const KEY = 'canapyra-role';

export const useRoleStore = create<RoleState>((set, get) => ({
  role: readLS<RoleId>(KEY, 'member'),
  setRole: (r) => {
    writeLS(KEY, r);
    set({ role: r });
  },
  hasLaudo: () => ROLES[get().role].hasLaudo,
}));

export const useRole = (): RoleId => useRoleStore((s) => s.role);
export const useHasLaudo = (): boolean => useRoleStore((s) => ROLES[s.role].hasLaudo);
